"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var StatusWarningFilledSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M10.7037499,3.9623322 L15.7092882,11.9592754 C15.9070807,12.2850514 16.000829,12.6448689 16.000061,13 C15.9984263,13.6741191 15.6560657,14.3313518 15.0376694,14.7068067 C14.7247801,14.8967752 14.3657565,14.9972317 13.9997131,14.9972317 L4,14.9999236 C2.8954305,14.9999236 2,14.1045695 2,13 C2,12.6339566 2.10045645,12.2749331 2.29042497,11.9620437 L7.28459986,3.9623322 C7.66164996,3.34130849 8.32287747,2.99867105 9,2.99992355 C9.35233944,3.00069152 9.70898264,3.09451612 10.0321312,3.29071343 C10.3066867,3.45740786 10.5370555,3.68777667 10.7037499,3.9623322 Z M9,6 C8.44771525,6 8,6.44771525 8,7 L8,9 C8,9.55228475 8.44771525,10 9,10 C9.55228475,10 10,9.55228475 10,9 L10,7 C10,6.44771525 9.55228475,6 9,6 Z M9,11 C8.44771525,11 8,11.4477153 8,12 C8,12.5522847 8.44771525,13 9,13 C9.55228475,13 10,12.5522847 10,12 C10,11.4477153 9.55228475,11 9,11 Z" })));
};
StatusWarningFilledSmall.displayName = 'StatusWarningFilledSmall';
exports.default = StatusWarningFilledSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=StatusWarningFilledSmall.js.map